// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VlXF","rightAdornment":"Header_rightAdornment__2j2PG"};